import React from 'react'
import TooltipHLPure from '../tooltipHL/tooltipHL.pure'

function StatCard(props) {
    const { className, title, value, tooltip } = props;

    return (
        <div className={`dashboardView-card ${className}`}>
            <div className="dashboardView-card-titleRow">
                <p className="dashboardView-card-title">{title}</p>
                {tooltip && (
                    <TooltipHLPure
                        positionTooltip={tooltip.position}
                        tooltipClassName="tooltipHLPure-constrained"
                        titleTooltip={tooltip.title}
                        descriptionTooltip={tooltip.description}
                        subContent={tooltip.subContent}
                        restContent={tooltip.restContent}
                        informationIcon={true}
                    />
                )}
            </div>
            <p className="dashboardView-card-value">{value}</p>
        </div>
    )
}

export default StatCard
